import * as React from 'react';
import { CSSProperties } from 'react';

interface Props {
    width?: number;
    height?: number;
    color?: string;
}

const cls1Style: CSSProperties = {
    fill: '#4680ff'
};
const cls2Style: CSSProperties = {
    fill: '#fff',
    fontSize: 30 + 'px',
    fontFamily: 'Helvetica-Bold, Helvetica',
    fontWeight: 700,
};
const cls3Style: CSSProperties = {
    fill: '#fff'
};
const cls4Style: CSSProperties = {
    fill: '#2865ef',
    fillRule: 'evenodd',
};

export class FacebookButton extends React.Component<Props, {}> {
    // TODO: update with re-exported SVG's to remove whitespace

    public render(): JSX.Element | null {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="-6097 2621 429 114"
                width={this.props.width}
                height={this.props.height}
            >
                <g id="FacebookButton" transform="translate(-6442 1885)">
                    <rect id="Rectangle_95" data-name="Rectangle 95" style={cls1Style} width="429" height="114" rx="57" transform="translate(345 736)"/>
                    <text id="Facebook" style={cls2Style} transform="translate(384 804)"><tspan x="0" y="0">Facebook</tspan></text>
                    <g id="Symbol_3_5" data-name="Symbol 3 – 5" transform="translate(672 743.5)">
                        <g id="Group_76" data-name="Group 76">
                            <circle id="XMLID_18_" style={cls3Style} cx="45.6" cy="45.6" r="45.6" transform="translate(0 4.5)"/>
                        </g>
                        <path id="XMLID_1_" style={cls4Style} d="M38.4,63.9V51.1c0-.7-.2-.9-.9-.9-1.3.1-2.7,0-4,0-.5,0-.7-.1-.7-.7v-8c0-.5.1-.7.7-.7h4.1c.8,0,1-.2.9-1V33.7a11.737,11.737,0,0,1,2.2-6.8,9.472,9.472,0,0,1,7.6-3.8c3.1-.1,6.3-.1,9.4-.1a.53.53,0,0,1,.6.6v8.1c0,.5-.2.6-.6.6H53.2c-2,0-3.2,1-3.3,3-.1,1.6,0,3.2-.1,4.8,0,.6.3.5.7.5h6.9c.7,0,.9.1.8.9-.3,2.7-.5,5.4-.8,8-.1.6-.3.7-.9.7H51.1c-1.3,0-1.2-.2-1.2,1.1V76.4c0,.9-.2,1.1-1.1,1.1q-4.65-.15-9.3,0c-.9,0-1-.3-1-1.1C38.5,72.3,38.4,68.1,38.4,63.9Z"/>
                    </g>
                </g>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/FacebookButton.tsx